module.exports = __webpack_public_path__ + "img/b7864e6.png";